import React from 'react';
import { Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import SearchOrders from '../components/SearchOrders/SearchOrders';
import TestimonialSubmit from '../components/Testimonial/testimonialSubmit';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export default function RouterProject() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_CAPTCHA_SITE_KEY}>
      <BrowserRouter>
        <Routes>
          <Route index path="/" exact={true} element={<SearchOrders />} />
          <Route path="*" exact={true} element={<SearchOrders />} />
          <Route path="/pages/share-your-wedding-flair" exact={true} element={<SearchOrders />} />
          <Route
            path="/pages/share-your-wedding-flair-entry"
            exact={true}
            element={<TestimonialSubmit />}
          />
        </Routes>
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  );
}
